import RewardsSearchResultList from './RewardsSearchResultList';

export default RewardsSearchResultList;
